<div class="report-confirm" role="dialog" aria-modal="true" aria-labelledby="report-confirm-title">

  <button class="close" type="button" (click)="cancel()" aria-label="Cerrar">
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
      <path d="M15 5L5 15M5 5l10 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    </svg>
  </button>

  <div class="report-confirm-icon" aria-hidden="true">
    <img src="assets/agricola/toast-idea.svg" alt="">
  </div>

  <h2 id="report-confirm-title" class="report-confirm-title">
    Tu solicitud se ha recibido y está en proceso
  </h2>

  <p class="report-confirm-label">Numero de solicitud es:</p>
  <p class="report-confirm-id">{{ data.requestId }}</p>

  <div class="report-confirm-actions">
    <button class="cancel-btn" type="button" (click)="cancel()">CANCELAR</button>
    <button class="apply-button" type="button" (click)="accept()">ACEPTAR</button>
  </div>

</div>
